import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Login } from './Login';
import './App.css';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { auth } from './firebase';
import { User } from 'firebase/auth';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/private-route';
import MessagingPage from './pages/messaging/messages_page';
import { useTranslation } from 'react-i18next';
import HomePage from './pages/home/HomePage';
import PuzzleDetailsPage from './pages/puzzles/PuzzleDetailsPage';
import PuzzleCreatePage from './pages/puzzles/PuzzleCreatePage';
import PuzzleEditPage from './pages/puzzles/PuzzleEditPage';
import PuzzlesPage from './pages/puzzles/PuzzlesPage';

function App() {
  const { i18n } = useTranslation();

  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });

    return unsubscribe;
  }, [i18n.language]);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="/course" element={<HomePage />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin">
            <Route index element={<PrivateRoute />} />
            <Route path="dashboard" element={<PrivateRoute />}>
              <Route path="" element={<DashboardPage />} />
            </Route>
            <Route path="puzzles" element={<PrivateRoute />}>
              <Route path="" element={<PuzzlesPage />} />
              <Route path=":id" element={<PuzzleDetailsPage />} />
              <Route path="create" element={<PuzzleCreatePage />} />
              <Route path="edit/:id" element={<PuzzleEditPage />} />
            </Route>
            <Route path="messaging" element={<PrivateRoute />}>
              <Route path="" element={<MessagingPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App;
